/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Join_Board_DescriptionInputs */

const en_directory_vibebids_join_board_description = /** @type {(inputs: Directory_Vibebids_Join_Board_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a real product URL and choose the category where you want to compete.`)
};

const zh_directory_vibebids_join_board_description = /** @type {(inputs: Directory_Vibebids_Join_Board_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交真实的产品网址，并选择你想参与竞争的分类。`)
};

/**
* | output |
* | --- |
* | "Submit a real product URL and choose the category where you want to compete." |
*
* @param {Directory_Vibebids_Join_Board_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_join_board_description = /** @type {((inputs?: Directory_Vibebids_Join_Board_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Join_Board_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_join_board_description(inputs)
	return zh_directory_vibebids_join_board_description(inputs)
});
export { directory_vibebids_join_board_description as "directory.vibebids.join_board_description" }